export default __webpack_public_path__ + "static/media/nifc_black_en.ad58d176.png";